<script>
import Layout from '@layouts/main.vue'
import UserProfile from '../components/user-profile.vue'

export default {
  components: { Layout, UserProfile },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
}
</script>

<template>
  <Layout>
    <UserProfile :user="user"></UserProfile>
  </Layout>
</template>
